import React from "react";
import { ExclamationIcon } from "../../assets/iconComponents/ExclamationIcon";
import { SuccessUploadIcon } from "../../assets/iconComponents/SuccessUploadIcon";
import { DetailedRequisitionSerializer } from "../../recoil/types";
import { FileUploaderSubmitButton } from "./FileUploader.styles";
import { GetTreatmentNotesDownloadURL } from "./Services/UserReportService";

import {
  ErrorText,
  ErrorWrapper,
  GeneralInfoText,
  GeneralInfoWrapper,
  UserReportGenerateNotesConfirmationGrid,
  UserReportGenerateNotesConfirmationsWrapper,
  UserReportGenerateNotesConfirmationText,
  UserReportGenerateNotesConfirmationTextWrapper,
  UserReportGenerateNotesDownloadFile,
  UserReportGenerateNotesDownloadLink,
  UserReportGenerateNotesWrapper,
} from "./UserReport.styles";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";

const TreatmentNotesUpload: React.FC<{
  fullReport: DetailedRequisitionSerializer;
  setGenerateNotesModalOpen: React.Dispatch<
    React.SetStateAction<DetailedRequisitionSerializer | undefined>
  >;
  recentDownload: boolean;
}> = ({ fullReport, setGenerateNotesModalOpen, recentDownload }) => {
  const { auth, setLoggedOut } = useAuthenticationHook();

  const getClinicalNotesMessage = (generated?: boolean): React.ReactElement => {
    if (generated) {
      return (
        <UserReportGenerateNotesConfirmationTextWrapper>
          <div>{`Treatment notes have been generated and submitted to BillionToOne${
            recentDownload
              ? ", and a local copy has been downloaded for your records"
              : ""
          }.`}</div>
          <UserReportGenerateNotesDownloadFile
            onClick={async () => {
              try {
                const results = await GetTreatmentNotesDownloadURL(
                  auth!.token,
                  fullReport.sfid || "",
                  setLoggedOut,
                );
                const pdf = await results.json();
                const tempAnchor = document.createElement("a");
                tempAnchor.download = "file.pdf";
                tempAnchor.target = "_blank";
                if (pdf) {
                  tempAnchor.href = pdf;
                  tempAnchor.click();
                }
                tempAnchor.remove();
              } catch (e) {
                //
              }
            }}
          >
            DOWNLOAD
          </UserReportGenerateNotesDownloadFile>
        </UserReportGenerateNotesConfirmationTextWrapper>
      );
    }
    return <></>;
  };

  return (
    <GeneralInfoWrapper>
      <GeneralInfoText id="req-treatment-notes">
        TREATMENT NOTES
      </GeneralInfoText>
      {fullReport.is_missing_treatment_notes && (
        <ErrorWrapper>
          <ErrorText>
            <ExclamationIcon />
            <div style={{ paddingTop: "3px" }}>
              Please generate treatment notes for this patient.
            </div>
          </ErrorText>
        </ErrorWrapper>
      )}
      {fullReport.has_generated_treatment_notes && (
        <UserReportGenerateNotesConfirmationsWrapper>
          <UserReportGenerateNotesConfirmationGrid>
            <SuccessUploadIcon />
            <UserReportGenerateNotesConfirmationText>
              {getClinicalNotesMessage(
                fullReport.has_generated_treatment_notes,
              )}
            </UserReportGenerateNotesConfirmationText>
          </UserReportGenerateNotesConfirmationGrid>
        </UserReportGenerateNotesConfirmationsWrapper>
      )}
      {!fullReport.has_generated_treatment_notes && (
        <>
          <UserReportGenerateNotesWrapper>
            <FileUploaderSubmitButton
              onClick={() => setGenerateNotesModalOpen(fullReport)}
              disabled={false}
            >
              GENERATE NOTES
            </FileUploaderSubmitButton>
          </UserReportGenerateNotesWrapper>
          <UserReportGenerateNotesDownloadLink
            onClick={() => {
              const hashElement = document.querySelector(
                "#billing-file-uploader",
              );
              hashElement?.scrollIntoView();
            }}
          >
            <p>or Upload Documents Below</p>
          </UserReportGenerateNotesDownloadLink>
        </>
      )}
    </GeneralInfoWrapper>
  );
};

export default TreatmentNotesUpload;
